import React from 'react';
import {Button, Checkbox, Modal} from "antd";
import BaseComponent from "../../../../base/BaseComponent";
import {message} from "../../../../utils/message";
import {Scrollbars} from "react-custom-scrollbars";
import TopNavigation from "./TopNavigation";
import PageTemplate from "../../../newMediaMatrix/components/pageTemplate/PageTemplate";
import {getMaxWidth} from "../../../statisticalAnalysis/statisticsTable/utils";
import TableTemplate from "../../../newMediaMatrix/components/TableTemplate/TableTemplate";
import {uuid} from "../../../../utils";
import PositionAdd from "../info/PositionAdd";
import TransferPersonSelect from "../TransferPersonSelect";

export default class BatchTransfer extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            listData: [],
            transferPersonBtnShow: true,
            checkedItem: {}
        }
    }

    componentDidMount() {
        this.getBatchTransferData()
    }

    getBatchTransferData() {
        let body = {};
        this.request({
            url: "/cm-sites-media-consumer/position/handler/batchTransferPositions",
            body: body,
            callBack: (data) => {
                let listData = [];
                if (data && data.length) {
                    listData = data.map(item => {
                        return {
                            ...item,
                            checked: false
                        }
                    });
                }
                this.setState({
                    listData
                })
            },
            errorCallBack: () => {

            },
            serverVerify: {
                serverErrorCallBack: () => {

                }
            }
        });
    }

    checkedAll(checked) {
        this.state.listData.forEach(item => {
            item.checked = checked;
        });
        this.setState({})
    }

    getColumns() {
        const {listData} = this.state;
        return (
            [
                {
                    title: (() => {
                        let checkedAll = listData.length ? listData.every(item => item.checked) : false;
                        let checkedLength = listData.length ? listData.filter(item => item.checked).length : 0
                        let indeterminate = listData.length && checkedLength > 0 && checkedLength < listData.length;
                        return (
                            <Checkbox checked={checkedAll} indeterminate={indeterminate} onChange={(e) => {
                                this.checkedAll(e.target.checked);
                            }}/>
                        )
                    })(),
                    align: 'center',
                    width: 50,
                    key: "checked",
                    render: (record) => {
                        return (
                            <div>
                                <Checkbox checked={record.checked} onChange={() => {
                                    record.checked = !record.checked;
                                    this.setState({})
                                }}/>
                            </div>
                        )
                    }
                },
                {
                    title: "账号名称",
                    dataIndex: "name",
                    key: "name",
                    ellipsis: true
                },
                {
                    title: "账号状态",
                    dataIndex: "statusName",
                    key: "statusName",
                    ellipsis: true
                },
                {
                    title: "媒体平台",
                    dataIndex: "positionTypeName",
                    key: "positionTypeName",
                    ellipsis: true
                },
                {
                    title: "账号logo",
                    dataIndex: "logo",
                    key: "logo",
                    render: (text, record) => {
                        return (
                            <>
                                {/*此logo是通过后台配置项而来*/}
                                <img alt={"账号logo"} src={record.logo}
                                     style={{
                                         width: 25,
                                         height: 25,
                                         borderRadius: "50%",
                                         objectFit: "cover"
                                     }}/>
                            </>
                        );
                    }
                },
                {
                    title: "主责单位",
                    dataIndex: "mainDeptName",
                    key: "mainDeptName",
                    ellipsis: true
                },
                {
                    title: "负责人",
                    dataIndex: "leader",
                    key: "leader",
                    ellipsis: true,
                    render: (text, record) => record?.ext?.leader
                },
                {
                    title: "联系电话",
                    dataIndex: "contact",
                    key: "contact",
                    ellipsis: true
                },
                // {
                //     title: "操作",
                //     dataIndex: "operation",
                //     key: "operation",
                //     render: (text, record) => {
                //         return (
                //             <>
                //                 <span style={{color: "#0050B3", marginRight: 10, cursor: "pointer"}}
                //                       onClick={() => this.positionAdd.onlyEditInfo(record.id, false)}>查看</span>
                //             </>
                //         );
                //     }
                // }
            ]
        )
    }

    renderTransferBy() {
        let transferNameBy = this.state.checkedItem.name;
        return (
            <div style={{paddingBottom: 15}}>
                {
                    this.state.transferPersonBtnShow ?
                        <div><Button
                            style={{cursor: "pointer"}} type={"primary"}
                            onClick={() => {
                                this.transferPersonSelect.openModal()
                            }}>选择被转交人</Button>
                        </div>
                        : <div>
                            <Button
                                style={{cursor: "pointer"}} type={"primary"}
                                onClick={() => {
                                    this.transferPersonSelect.openModal(() => {
                                        this.transferPersonSelect.setData(this.state.checkedItem)
                                    })
                                }}>重新选择</Button>
                            <span style={{padding: "0 10px"}}>{transferNameBy}</span>
                        </div>
                }
            </div>
        )
    }

    topMenuHeight = 70;
    topNavigation = 56;
    screenHeight = 47;
    pagePadding = 15;  // 页面margin
    pageMargin = 15;  // 页面margin
    bottomBtn = 63;  // 底部按钮高度
    otherHeight = this.topNavigation + this.pagePadding * 2 + this.pageMargin * 2 + this.screenHeight + this.bottomBtn + this.topMenuHeight; // 除表格外的其他所有高度集合
    tableAutoHeight = `calc(100vh - ${this.otherHeight + "px"})`;
    loadKey = uuid();
    transferPersonSelectKey = uuid();

    setTransferPerson(checkedItem, callback) {
        this.state.checkedItem = checkedItem;
        this.state.transferPersonBtnShow = false;
        callback();
        this.setState({})
    }

    renderFooter = () => {
        return (
            <>
                <Button onClick={() => {
                    this.goBack()
                }}>返回</Button>
                <Button type={"primary"} style={{marginLeft: "24px"}} onClick={() => {
                    this.onOk()
                }}>确认转交</Button>
            </>
        )
    };

    //返回
    goBack() {
        window.location.hash = "/newMedia/positionManage";
    };

    // 表单校验
    checkForm = () => {
        if (this.state.listData.every(item => item.checked === false)) {
            message.warn("请选择需要批量转交的数据！");
            return false;
        }
        if (!this.state.checkedItem._id) {
            message.warn("请选择被转交人！");
            return false;
        }
        return true;
    };

    // 保存
    onOk = () => {
        let that = this;
        let body = that.checkForm();
        if (!body) {
            return false
        }
        Modal.confirm({
            title: '请注意，转交操作不可逆',
            content: "",
            okText: '继续',
            cancelText: '取消',
            onOk() {
                that.save()
            },
            onCancel() {
            },
        })
    };

    getBody = () => {
        let {listData, checkedItem} = this.state;
        let data = listData.filter(item => item.checked === true);
        let codes = data.map(item => item.code);
        let deptId = checkedItem.deptList?.[0]?._id || "";
        return {
            codes,
            receiverAccount: checkedItem._id,
            receiverDeptId: deptId,
        }
    }

    // 暂存
    save = () => {
        let body = this.getBody();
        let url = '/cm-sites-media-consumer/position/handler/transferPositions';
        // 获取流程状态
        this.request({
            url,
            method: 'POST',
            body: body,
            callBack: (res) => {
                if (res) {
                    message.success('批量转交成功！');
                    this.getBatchTransferData();
                } else {
                    message.warn('批量转交失败！');
                }
            },
            errorCallBack: function (e) {
                message.warn('批量转交失败！');
            }
        });
    };

    render() {
        const columns = this.getColumns();
        const {tabKey = 'BatchAudit', listData} = this.state;
        return (
            <>
                <PageTemplate styleOut={{marginBottom: 0}} style={{
                    borderRadius: "5px 5px 0 0",
                    borderBottom: "1px solid #ddd",
                    padding: "15px 32px"
                }}>
                    <TopNavigation
                        batchTitle={"批量转交"}
                        goBack={() => this.goBack()}
                        onResize={(offsetHeight) => {
                            if (this.topNavigation != offsetHeight) {
                                this.topNavigation = offsetHeight;
                                this.setState({});
                            }
                        }}/>
                </PageTemplate>
                <PageTemplate styleOut={{margin: "0 15px"}} style={{borderRadius: 0, padding: "15px 32px"}}>
                    {this.renderTransferBy()}
                    <Scrollbars autoHide autoHeight autoHeightMax={this.tableAutoHeight}>
                        <TableTemplate
                            key={"TableTemplate" + tabKey}
                            maxWidth={getMaxWidth(this.pageMargin * 2 + this.pagePadding * 2)}
                            maxHeight={this.tableHeight}
                            columns={columns}
                            dataSource={listData}
                            onResize={(offsetHeight) => {
                                if (this.tableHeight != offsetHeight) {
                                    this.tableHeight = offsetHeight;
                                    this.setState({});
                                }
                            }}
                        />
                    </Scrollbars>
                </PageTemplate>
                <PageTemplate styleOut={{margin: "0 15px"}} style={{
                    borderRadius: "0 0 5px 5px",
                    padding: "15px 32px",
                    borderTop: "1px solid #ddd",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    {this.renderFooter()}
                </PageTemplate>
                <PositionAdd
                    key={this.loadKey}
                    ref={ref => this.positionAdd = ref}
                    dynamicParams={() => {
                    }}
                    onCancel={() => {
                        // 重新加载新增流程
                        this.loadKey = uuid();
                        this.setState({})
                    }}
                    onOkCall={() => {
                        // 重新加载新增流程
                        this.loadKey = uuid();
                        this.screenCardKey = uuid();
                        this.getBatchTransferData();
                    }}
                />
                <TransferPersonSelect
                    title={"选择被转交人"}
                    key={this.transferPersonSelectKey}
                    ref={ref => this.transferPersonSelect = ref}
                    onCancel={() => {
                        this.transferPersonSelectKey = uuid();
                        this.setState({})
                    }}
                    checkedItem={this.state.checkedItem}
                    onOkCall={(checkedItem, callback) => {
                        this.transferPersonSelectKey = uuid();
                        this.setTransferPerson(checkedItem, callback)
                    }}
                />
            </>
        )
    }

}
